import React from 'react'
import { useSelector } from 'react-redux'
import {
  pathOr
} from 'ramda'
import ReactSVG from 'react-svg'
import classNames from 'classnames'

import { LOADING_OVERLAY } from '../../constants'
import { getLocationBaseWithHref } from '../../lib/location'
import neonLoadingImg from '../../../images/neon/loading-white.svg'
import neonCheckImg from '../../../images/neon/check.svg'
import styles from './loading-overlay.css'

const loadingOnPlayer = (message) => {
  const loadingMsg = pathOr('', ['operations', 'playerLoading', 'loadingMsg'], LOADING_OVERLAY)
  const successMsg = pathOr('', ['operations', 'playerLoading', 'successMsg'], LOADING_OVERLAY)
  return message === loadingMsg || message === successMsg
}

function renderLoaderMessage(loader) {
  if (loader.loading) {
    return (
      <div className={styles.loadingMsg}>{loader.message}</div>
    )
  }

  if (loader.error) {
    return (
      <div className={styles.errorMsg}>{loader.message}</div>
    )
  }

  const isPlayer = loadingOnPlayer(loader.message) || getLocationBaseWithHref().includes('watch')

  return (
    <div
      data-e2e="success-msg-loader"
      className={classNames({
        [styles.successMsg]: !isPlayer,
        [styles.hideLoadingMsg]: isPlayer
      })}
    >
      {loader.message}
    </div>
  )
}

/**
 * Displays global loading, success, and error feedback for active operations
 * stored in Redux.
 */
function LoadingOverlay() {
  const loaders = useSelector(state => state.loading)

  if (!loaders.length) {
    return null
  }

  const isLoading = loaders.some(loader => loader.loading)
  const isPlayer = loadingOnPlayer(loaders[0].message)
  const hasError = loaders.some(loader => loader.error)
  const successImg = hasError
    ? null
    : (
      <ReactSVG
        src={neonCheckImg}
        beforeInjection={(svg) => {
          svg.setAttribute('class', classNames({
            [styles.completed]: !isPlayer,
            [styles.hideLoadingMsg]: isPlayer
          }))
        }}
      />
    )

  return (
    <div
      className={styles.wrapper}
      data-lbx-e2e="loading-overlay"
    >
      <div>
        {
          !isLoading
            ? successImg
            : (
              <ReactSVG
                src={neonLoadingImg}
                beforeInjection={(svg) => {
                  svg.setAttribute('class', styles.loading)
                }}
              />
            )
        }
      </div>
      {
        loaders.map(loader => (
          <div key={loader.key}>
            {renderLoaderMessage(loader)}
          </div>
        ))
      }
    </div>
  )
}

export default LoadingOverlay
